import { render } from "./TextInputEditor.vue?vue&type=template&id=444ce93f&scoped=true"
import script from "./TextInputEditor.vue?vue&type=script&lang=ts"
export * from "./TextInputEditor.vue?vue&type=script&lang=ts"

import "./TextInputEditor.vue?vue&type=style&index=0&id=444ce93f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-444ce93f"

export default script